import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import { PARAMS } from "../../config";

const BidderQualityTable = ({ report, total, onSortChange }) => {
    const headers = PARAMS.map(([ param, label ]) => <th key={param} onClick={() => onSortChange(param)}>{label}</th>);
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    {headers}
                </tr>
            </thead>
            <tbody>
                <TotalRow data={total} />
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderQualityTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderQuality/components/Table/index.js